import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-one-screen",
  "use": "icon-one-screen-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-one-screen\">\r\n  <defs>\r\n    <style>\r\n      #icon-one-screen .cls-1 {\r\n        fill: #b2bbc8;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-one-screen_单屏\" class=\"cls-1\" d=\"M3.188,43.733H13.812V36.267H3.188Zm1.062-6.4h8.5v5.333H4.25ZM1.063,36.267v-3.2H4.25V32H0v4.267Zm14.875,0H17V32H12.75v1.067h3.187Zm0,10.667H12.75V48H17V43.733H15.937Zm-14.875-3.2H0V48H4.25V46.933H1.063Z\" transform=\"translate(0 -32)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol